var Payment = {
  initializePopover: function (selector) {
    Utility.initManualPopover(selector);
  },

  /**
   * Alerts if any fields with class 'required' have empty values.
   *
   * @param container the parent html element to search within
   * @returns {boolean} true if all required fields are present
   */
  verifyRequired: function (container, required_class) {
    required_class = ((required_class === null || typeof(required_class) === 'undefined') ? 'required' : required_class);
    var is_ok = true;
    $(container).find("input." + required_class + ", select." + required_class).each(function () {
      var val = $(this).val();
      if (val === null || /^\s*$/.test(val)) {
        is_ok = false;
        alert('Please enter all required fields.');
        return false;
      }
    });
    return is_ok;
  },

  verifyCC: function (container) {
    $(".flash-error").remove();

    var card_number = container.find("#order_card_number");
    var card_type = container.find("#order_card_type").val();

    // Skip this validation if there's no card number field since it's an electronic check payment
    if (card_number.length === 0) {
      return true;
    }

    var first_digit = card_number.val().charAt(0);

    if (card_number.val() !== "" &&
      ((card_type === "american_express" && first_digit !== "3") ||
        (card_type === "visa" && first_digit !== "4") ||
        (card_type === "master" && first_digit !== "5") ||
        (card_type === "discover" && first_digit !== "6")) ||
      (first_digit < "3" || first_digit > "6")) {
      alert("The credit card number you entered is not valid for the card type you selected.");
      $('.sa-form-submit-button .btn-primary').buttonState('reset');
      return false;
    }

    if ($("#fee-notification").length > 0 && !$("#fee-notification").is(':checked')) {
      alert("You must accept the terms and conditions before submitting payment.");
      $('.sa-form-submit-button .btn-primary').buttonState('reset');
      return false;
    }

    $('.payment-details[data-type=credit]').find('#order_submit, .nmi_submit').buttonState('loading');
    return true;
  },

  initializeAcceptedCC: function () {
    $('input[name^="commit"]').click(function (e) {
      var checkboxes = $('input[name^="customer[accepted_credit_cards][]"]');

      if (checkboxes.length && !checkboxes.is(":checked")) {
        alert("You must select at least one accepted credit card type.");
        e.preventDefault();
      }
    });
  },

  changePaymentType: function (payment_type, entity_type, entity_id) {
    var url;

    switch(entity_type) {
      case "ad_hoc_form":
        url =  Routes.ad_hoc_form_update_payment_path(entity_id);
        break;
      case "applications":
        url =  Routes.application_update_payment_path(entity_id);
        break;
      case "contracts":
        url =  Routes.contracts_update_payment_path(entity_id);
        break;
    }

    $.ajax({
      type: "GET",
      data: {payment_method: payment_type},
      url: url,
      beforeSend: function () {
        $('body').addClass('loading');
      },
      success: function (data) {
        $("#payment_detail").html(data);
        $(".flash, .errorExplanation").remove();
      },
      complete: function () {
        $('body').removeClass('loading');
        Payment.initializePopover("#cvv-help i");
      }
    });
  },

  bindCountrySelector: function () {
    var stateDropdown = $('#billing-state');

    $('#billing-country').change(function () {
      if ($(this).val() != "US") {
        $('#billing-state').replaceWith('<input type="text" id="billing-state" class="col-24">');
        $("label:contains('State')").replaceWith('<label class="sub-field-label">State/Province</label>');
      } else {
        $('#billing-state').replaceWith(stateDropdown);
        $("label:contains('State/Province')").replaceWith('<label class="label-required sub-field-label">State</label>');
      }
    });
  }
};

global.Payment = global.Payment || Payment;
